import React from 'react';
import Etsa from 'assets/images/etsy.png';
import WooCommerceLogo from 'assets/svg/WooCommerceLogo';
import Shopify from 'assets/images/shopify.png';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  Container,
  Wrapper,
  IntegrationSection,
  KeyFeatures,
} from 'styles/pages/home/integration';

const Integration = () => (
  <Container id='key-features'>
    <Wrapper>
      <IntegrationSection>
        <h4>We integrate seamlessly with</h4>
        {/* <img src={Etsa} alt='Etsa' /> */}
        <img src={Shopify} alt='Shopify' />
        <WooCommerceLogo style={{ opacity: 0.5 }} />
      </IntegrationSection>
      <KeyFeatures>
        <h2>Key Features</h2>
        <div>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
          <p>
            <CheckCircleIcon />
            Manage multiple stores
          </p>
        </div>
      </KeyFeatures>
    </Wrapper>
  </Container>
);

export default Integration;
